

































import Vue from "vue";
import Component from 'vue-class-component';
import StarIcon from 'vue-material-design-icons/Star.vue';

@Component({
    components: { StarIcon },
})
export default class DetalhesAgregado extends Vue {
    public image = require("@/assets/images/tow-addon.svg");

    get content () {
        return this.$store.state.cotacao.assistencia_agregado;
    }

    set content (value) {
        this.$store.commit('SET_AGREGADO', value);
    }
}
